module.exports = __webpack_public_path__ + "img/maps-and-flags.bbd86674.png";